export function getOption (data, flag) {
  const color = flag == 2 ? '#ecbf05' : flag == 888 ? '#2ac2eb' : '#1AB42D';
  return {
    // 图表主标题
    title: false,
    // 提示框组件
    tooltip: false,
    series: [{
      type: 'liquidFill',
      radius: '78%', // 水球图的半径
      center: ['50%', '50%'], // 水球图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
      // 水填充图的形状 circle 默认圆形  rect 圆角矩形  triangle 三角形  
      // diamond 菱形  pin 水滴状 arrow 箭头状  还可以是svg的path
      shape: 'circle',
      phase: 0, // 波的相位弧度 不设置  默认自动
      direction: 'right', // 波浪移动的速度  两个参数  left 从右往左 right 从左往右
      outline: {
        show: true,
        borderDistance: 0, // 边框线与图表的距离 数字
        itemStyle: {
          opacity: 0.6, // 边框的透明度   默认为 1
          borderWidth: 2, // 边框的宽度
          borderColor:color// 边框颜色
        }
      },
      backgroundStyle: {
        color: "#0C2A3D", // 水球未到的背景颜色
        opacity: 0.5
      },
      // 图形的高亮样式
      emphasis: {
        itemStyle: {
          opacity: 0.8 // 鼠标经过波浪颜色的透明度
        }
      },
      // 图形上的文本标签
      label: {
        normal: {
          formatter: function(param) {
            let val = Number(param.value * 100).toFixed(2);
            if (flag === 2) return '总数';
            if (flag == 888) return `${val}%`;
            return '正常'
          },
          fontSize: 16,
          fontWeight: 400,
          color: '#fff',
        }
      },
      data: [
        { value: data + 0.1, itemStyle: { color: `rgba($color: ${color}, $alpha: 0.3)` } },
        { value: data, itemStyle: { color } },
      ]
    }]
  }
}
